export const AccordionHeaderParamsTexts = {
  HeaderDefaultTitle: 'Паспортные данные',
  HeaderDefaultDescription: 'Заполните данные',
};
